<template>

</template>

<script>

  function unifyEvent(e) { return e.changedTouches ? e.changedTouches[0] : e };

  export default {
    mounted: function () {
      this.$store.commit('setTitle', null);
      this.$store.commit('setHero', {
        slides: [...this.$store.state.hero.originalSlides],
        showSlideShow: true,
      });
    },

    data() {
      return {
      };
    },
    
    methods: {
    },
    destroyed () {
    }
  };
</script>

<style lang="scss">
  @import 'style.scss';

</style>
